import { useState } from "react";
import { useAuth } from "../../context/useAuth";
import { Link, useNavigate } from "react-router-dom";
import "./Auth.css";
import dpPowerWorld from "../../assets/images/DP_Power_world.png";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login({ email, password, rememberMe });
      navigate("/dashboard");
    } catch (err) {
      // toast handled in AuthProvider
    }
  };

  return (
    <div className="auth-card">
      <div className="auth-logo-wrap">
        <img
          src={dpPowerWorld}
          alt="DP Power World"
          className="auth-logo-img"
        />
      </div>
      <h1 className="auth-title">Login</h1>

      <form onSubmit={handleSubmit}>
        <div className="auth-field">
          <input
            className="auth-input no-extra-padding"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="auth-field">
          <div className="auth-input-wrap">
            <input
              className="auth-input"
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword((v) => !v)}
              className="auth-toggle-pwd"
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </button>
          </div>
        </div>

        <div className="auth-row">
          <label className="auth-checkbox-wrap">
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            Remember me
          </label>
          <Link to="/forgot-password" className="auth-link">
            Forgot password?
          </Link>
        </div>

        <button type="submit" className="auth-btn">
          Login
        </button>
      </form>

      <p className="auth-footer">
        Don&apos;t have an account?
        <Link to="/register" className="auth-link">
          Register
        </Link>
      </p>
    </div>
  );
}
